import { getDefaultNodeImage, getNodeImage, getNodeName } from "Areas/SharedFeatures/nodeLabel";
import NodeSourceAdditionalInfo from "./nodeSourceAdditionalInfo";
class NodeSource extends NodeSourceAdditionalInfo {
    constructor(NodeId, DocumentObject, NodeWidth, NodeHeight, AttributeValues, LargeAttributeValues, Created, Description, Color, RequestTaskId, SourceTaskId, GroupId, SourceCreated, PinnedToGroup, InputLinksCount, OutputLinksCount) {
        super(DocumentObject, Created, Description, Color, NodeWidth, NodeHeight, InputLinksCount, OutputLinksCount);
        this.NodeId = NodeId;
        this.DocumentObjectId = DocumentObject.Id;
        this.AttributeValues = AttributeValues || [];
        this.LargeAttributeValues = LargeAttributeValues || {};
        this.RequestTaskId = RequestTaskId;
        this.SourceTaskId = SourceTaskId;
        this.GroupId = GroupId;
        this.PinnedToGroup = Boolean(this.GroupId && PinnedToGroup);
        this.SourceCreated = SourceCreated;
        this.NodeImage = getNodeImage(this.AttributeValues, DocumentObject, true);
        const defaultNodeImage = getDefaultNodeImage(DocumentObject);
        this.NodeDefaultImage = defaultNodeImage !== this.NodeImage ? defaultNodeImage : undefined;
        this.NodeName = getNodeName(this.AttributeValues, DocumentObject);
    }
}
export const NODE_SERVER_IGNORED_FIELDS = [
    "Height",
    "Id",
    "ParentId",
    "Ports",
    "Width",
    "X",
    "Y",
    "IsGroup",
    "NodeHeight",
    "NodeWidth",
    "GroupName",
    "GroupObjectCount",
    "DocumentObject",
    "NodeImage",
    "NodeDefaultImage",
    "NodeName"
];
export const NODE_JSON_SERVER_IGNORED_FIELDS = ["Tag"];
export default NodeSource;
